import roomBackgroundImage from './IntroRoom/bg.jpg'
import React, { useEffect } from 'react'
import ReactGA from 'react-ga'
import { useLocation } from 'react-router-dom'

import Languages from './Languages/Languages'
import { useTranslation } from 'react-i18next'
import logo from '../assets/images/logo.png'
import Icon from '../assets/icons/Icon'
import theme from '../theme'

const Mobile = () => {
  let location = useLocation()

  useEffect(() => {
    ReactGA.pageview(location?.pathname + location?.search)
  }, [location])

  const { t } = useTranslation(['IntroRoom', 'Mobile'])
  return (
    <div
      style={{
        height: '100vh',
        width: '100vw',
        zIndex: 2,
        backgroundImage: `url(${roomBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        color: '#fff',
        padding: '7vh 4vw',
      }}
    >
      <div
        style={{
          height: '100%',
          width: '100%',
          position: 'relative',
        }}
      >
        <div
          style={{ position: 'absolute', top: '100px', left: '-60px', fontSize: '18px', transform: 'rotate(-90deg)' }}
        >
          {t('IntroRoom:projectName')}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            maxHeight: '700px',
            minHeight: '500px',
          }}
        >
          <Languages style={{ transform: 'rotate(0)', position: 'static' }} />
          <div style={{ maxWidth: '200px', fontSize: '16px', lineHeight: '20px' }}>
            <div style={{ textAlign: 'center' }}>{t('Mobile:part1')}</div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '25px' }}>
              <Icon name="desktop" fill={theme.white} width={29} height={24} className="desktop" />
              <Icon name="headphones" fill={theme.white} width={24} height={24} />
            </div>
            <div style={{ textAlign: 'center', marginBottom: '25px' }}>{t('Mobile:part2')}</div>
            <div style={{ textAlign: 'center' }}>{t('Mobile:thanks')}</div>
          </div>
          <div style={{ marginTop: '50px' }}>
            <img alt="Time suburbs logo" src={logo} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Mobile
